// extracted by mini-css-extract-plugin
export default {"tab":"NavigationTab_tab__Yr316","icon":"NavigationTab_icon__Mdw45","selected":"NavigationTab_selected__qbSa7"};